const axios = require('axios').default;
const client_id = process.env.ELATION_CLIENT_ID
const client_secret = process.env.ELATION_CLIENT_SECRET
const username = process.env.ELATION_API_USER_EMAIL
const password = process.env.ELATION_API_USER_PASSWORD
const base_url = process.env.ELATION_API_BASE_URL
const grant_type = "password"

const generateBasicAuth = () => {
    const str = `${client_id}:${client_secret}`;
    const buff = Buffer.from(str, 'utf-8');
    const base64 = buff.toString('base64');
    return `Basic ${base64}`
}

const generateBasicAccessToken = (accessToken) => {
    return `Basic ${accessToken}`
}

const getToken = async () => {
    try {
        let auth = await generateBasicAuth()
        console.log(auth)
        let body = {
            grant_type: grant_type,
            username: username,
            password: password
        }
        let response = await axios.post(`${base_url}/oauth2/token/`, qs.stringify(body), {
            headers: {
                'Authorization': auth,
                'content-type': 'application/x-www-form-urlencoded'
            },
            body
        })
        return response
    } catch (error) {
        // console.log(error.response)
        return error.response
    }
}

const getPatient = async (patientId, accessToken) => {
    try {
        let authHeader = await generateBasicAccessToken(accessToken)
        let response = await axios.get(`${base_url}/patients/${patientId}/`, {
            headers: {
                Authorization: authHeader
            }
        })
        return response
    } catch (error) {
        return error.response
    }
}

module.exports = {
    getToken,
    getPatient
}
